import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledMultilineTextField,
  StyledTableContainer,
} from "../StyledComponents";
import Suggestions from "../Utils/Suggestions";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Icon from "../Utils/Icons";
import { ProceduresTable } from "./ProceduresTable";
import { FIELD_SET_IDS } from "../config/defaults/fieldLayoutUtils";
import useSectionFieldLayout from "../config/hooks/useSectionFieldLayout";

const Procedures = ({
  sectionName,
  activeSection,
  isFocusedSection = activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  setData,
  startRecording,
  stopRecording,
  isAiEnabled,
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = useSectionFieldLayout(
    fieldLayoutProp,
    FIELD_SET_IDS.procedures,
  );
  console.log("Inside Procedures", data);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [autocompleteData, setAutoCompleteData] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [suggestApiCalled, setSuggestApiCalled] = useState(false);
  const [debounceFunctionCalled, setDebounceFunctionCalled] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [listeningOn, setListeningOn] = useState(false);
  const [newProcedure, setNewProcedure] = useState({
    term: "",
    id: null,
  });
  const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
  const [procedureName, setProcedureName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [procedures, setProcedures] = useState(data);
  const [validationErrors, setValidationErrors] = useState({
    term: "",
  });
  const [mouseDownOnOption, setMouseDownOnOption] = useState(false);

  const debounceTimeout = useRef(null); // Use useRef to persist timeout
  const skipEffect = useRef(false);
  const optionChosen = useRef(false);

  useEffect(() => {
    setProcedures(data);
  }, [data]);

  useEffect(() => {
    setAuthToken(sessionStorage.getItem("accessToken"));
  }, [sessionStorage.getItem("accessToken")]);

  useEffect(() => {
    // Dictation goes to the focused section only — several sections can be open at once.
    if (isFocusedSection) {
      let timerId;

      timerId = setTimeout(() => {
        setProcedureName(transcript);
      }, 3000);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [transcript]);
  useEffect(() => {
    if (skipEffect.current) {
      skipEffect.current = false; // reset after skipping
      return;
    }
    // Call the API with the debounced function when procedureName changes

    let timerOut = setTimeout(() => {
      if (procedureName.trim() !== "") {
        debouncedFilterCall(procedureName.toLowerCase());
      }
    }, 500);
    return () => clearInterval(timerOut);
  }, [procedureName]);

  const startListening = (key) => {
    // alert("MH SL");
    if (transcript) {
      resetTranscript();
    }
    // setActiveHistorySection("Family History");
    SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    setListeningOn(true);
  };
  const debouncedFilterCall = async (name) => {
    console.log("Debounce function called");
    let semanticTagForProcedures = "procedure";
    const postBody = {
      term: name,
      state: "active",
      semantictag: semanticTagForProcedures,
      acceptability: "synonyms",
      returnlimit: "100",
      refsetid: null,
      parentid: null,
      excludeparentconcept: false,
      fullconcept: true,
    };

    try {
      if (procedureName.length > 1) {
        const response = await axios.get(
          `${REACT_APP_BACKEND_ROUTE_URL}search_medical_services/?name=${name}&episode_type=OPD`,
          // postBody,
          { headers: headers }
        );
        if (response) {
          console.log("Snomed Response", response);
          if (
            response.data.status === "Success" &&
            response.data.data.length > 0
          ) {
            const dataToProcess =
              response.data.data.length > 300
                ? response.data.data.slice(0, 300)
                : response.data.data;

            const filteredData = dataToProcess.map((item) => {
              return {
                term: item.term,
                id: item.conceptId,
                source: item.source || "snomed",
                medical_service_id: item.medical_service_id || null,
              };
            });
            console.log("Filtered Procedure Data", filteredData);
            setAutoCompleteData(filteredData);
            setFilteredOptions(filteredData);
          } else {
            try {
              if (procedureName.length > 1) {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              }
            } catch (err) {
              console.log(err);
              toast.error(err);
            }
          }
          setDebounceFunctionCalled(true);
        }
      }
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };
  const validateFields = () => {
    const errors = {};

    if (
      fieldLayout.isFieldVisible("term", newProcedure) &&
      !newProcedure.term &&
      procedureName.length === 0
    ) {
      errors.term = fieldLayout.getValidationMessage(
        "term",
        "Procedures Name is a mandatory field.",
      );
    }

    if (
      fieldLayout.isFieldVisible("clinical_note", newProcedure) &&
      fieldLayout.isFieldRequired("clinical_note", newProcedure) &&
      !newProcedure.clinical_note?.trim()
    ) {
      errors.clinical_note = fieldLayout.getValidationMessage(
        "clinical_note",
        "Clinical Notes is a mandatory field.",
      );
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0; // Return true if no errors
  };
  // Function to handle adding a new row
  const handleAdd = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!optionChosen.current) {
      const postBody = {
        term: procedureName,
        state: "active",
        semantictag: "procedure",
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (procedureName.length > 1) {
          const response = await axios.get(
            `${REACT_APP_BACKEND_ROUTE_URL}search_medical_services/?name=${procedureName}&episode_type=OPD`,
            // postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === procedureName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                  medical_service_id: foundData.medical_service_id || null,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: procedureName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: procedureName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: procedureName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: procedureName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newProcedure,
                term: updatedFound.term,
                id: updatedFound.id,
                source: updatedFound.source || "snomed",
                medical_service_id: updatedFound.medical_service_id || null,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newProcedure,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
                source: "custom",
                medical_service_id: null,
              };
            }
          } else {
            newDetails = {
              ...newProcedure,
              term: procedureName,
              id: null,
              source: "custom",
              medical_service_id: null,
            };
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newProcedure,
          term: procedureName,
          id: null,
          source: "custom",
          medical_service_id: null,
        };
      }
    } else {
      newDetails = { ...newProcedure };
      if (!newDetails.source) {
        newDetails.source = "snomed";
      }
    }

    console.log("New Procedure Added", newDetails);

    // Add the new term to the complaints list
    let updatedDetails = [...procedures, newDetails];
    console.log("Procedure Updated Details", updatedDetails);
    setProcedures(updatedDetails);
    setNewProcedure({
      term: "",
      id: null,
      clinical_note: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setDebounceFunctionCalled(false);
    setTermSelectedOrAdded(false);
    setProcedureName("");
    setData(updatedDetails);
    optionChosen.current = false;
    setFilteredOptions([]);
  };

  // Function to handle input changes
  const handleInputChange = (field, value) => {
    let newDetails;
    if (field == "term") {
      setAutoCompleteData([]);
      setFilteredOptions([]);
      setTermSelectedOrAdded(true);
      newDetails = {
        ...newProcedure,
        [field]: value.term,
        id: value.id,
        source: value.source || "custom",
        medical_service_id: value.medical_service_id || null,
      };
    } else {
      newDetails = {
        ...newProcedure,
        [field]: value,
      };
    }

    setNewProcedure(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setProcedureName(procedures[index].term);
    setNewProcedure({ ...procedures[index], term: "", id: null });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails,
      updatedFound = {},
      updatedSelectedOptiondetsils = {},
      foundData = false;

    if (!optionChosen.current) {
      const postBody = {
        term: procedureName,
        state: "active",
        semantictag: "procedure",
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: true,
      };

      try {
        if (procedureName.length > 1) {
          const response = await axios.get(
            `${REACT_APP_BACKEND_ROUTE_URL}search_medical_services/?name=${procedureName}&episode_type=OPD`,
            // postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === procedureName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                  medical_service_id: foundData.medical_service_id || null,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: procedureName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: procedureName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: procedureName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: procedureName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            if (foundData) {
              console.log("updatedFound", updatedFound);
              newDetails = {
                ...newProcedure,
                term: updatedFound.term,
                id: updatedFound.id,
                source: updatedFound.source || "snomed",
                medical_service_id: updatedFound.medical_service_id || null,
              };
            } else {
              console.log(
                "updatedSelectedOptiondetsils",
                updatedSelectedOptiondetsils
              );
              newDetails = {
                ...newProcedure,
                term: updatedSelectedOptiondetsils.term,
                id: updatedSelectedOptiondetsils.id,
                source: "custom",
                medical_service_id: null,
              };
            }
          } else {
            newDetails = {
              ...newProcedure,
              term: procedureName,
              id: null,
              source: "custom",
              medical_service_id: null,
            };
          }
        }
      } catch (err) {
        console.log(err);
        // toast.error(err);
        newDetails = {
          ...newProcedure,
          term: procedureName,
          id: null,
          source: "custom",
          medical_service_id: null,
        };
      }
    } else {
      newDetails = { ...newProcedure };
      if (!newDetails.source) {
        newDetails.source = "snomed";
        newDetails.medical_service_id = null;
      }
    }
    let updatedDetails = procedures.map((data, i) =>
      i == editingIndex ? newDetails : data
    );
    setProcedures(updatedDetails);
    setEditingIndex(null);
    setNewProcedure({
      ...newProcedure,
      term: "",
      id: null,
    });
    setDebounceFunctionCalled(false);
    setTermSelectedOrAdded(false);
    setProcedureName("");
    setData(updatedDetails);
    setFilteredOptions([]);
    optionChosen.current = false;
  };
  // Function to handle row delete
  const handleDeleteRow = (index) => {
    let updatedDetails = procedures.filter((_, i) => i !== index);
    setProcedures(updatedDetails);
    setData(updatedDetails);
  };
  const memoizedHandleCrossButtonClick = useCallback(
    (sectionName, suggestionName, type) => {
      handleCrossButtonClick(sectionName, suggestionName, type);
    },
    [handleCrossButtonClick]
  );
  const handleClearName = () => {
    setValidationErrors({});
    setProcedureName("");
    resetTranscript();
    setNewProcedure({
      ...newProcedure,
      id: null,
      term: "", // Use computed property name to set the field dynamically
    });
    setFilteredOptions([]);
    setAutoCompleteData([]);
    setDebounceFunctionCalled(false);
    setTermSelectedOrAdded(false);
    // setMedicineList([])
  };
  // const handleAddOption = async (term) => {
  //   if (term.trim().length == 0) {
  //     const errors = {};
  //     errors.term = "You can't add an empty string";
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   const postBody = {
  //     term: term,
  //     state: "active",
  //     semantictag: "procedure",
  //     acceptability: "synonyms",
  //     returnlimit: "100",
  //     refsetid: null,
  //     parentid: null,
  //     excludeparentconcept: false,
  //     fullconcept: true,
  //   };

  //   try {
  //     if (procedureName.length > 1) {
  //       const response = await axios.post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
  //         postBody,
  //         { headers: headers }
  //       );
  //       if (response) {
  //         let updatedFound = {},
  //           updatedSelectedOptiondetsils = {},
  //           foundData = false;
  //         console.log("Snomed Response", response);
  //         if (
  //           response.data.status === "Success" &&
  //           response.data.data.length > 0
  //         ) {
  //           foundData = response.data.data.find((d) => d.term === term);
  //           console.log("Found Data", foundData);
  //           if (foundData) {
  //             updatedFound = {
  //               ...foundData,
  //               found: true,
  //               id: foundData.conceptId,
  //             };
  //           } else {
  //             updatedSelectedOptiondetsils = {
  //               hierarchy: null,
  //               isPreferredTerm: null,
  //               conceptState: null,
  //               conceptFsn: term,
  //               definitionStatus: null,
  //               conceptId: null,
  //               languageCode: "en",
  //               typeId: null,
  //               term: term,
  //               caseSignificanceId: "CASE_INSENSITIVE",
  //               id: null,
  //               effectiveTime: null,
  //               activeStatus: null,
  //               moduleId: null,
  //             };
  //           }
  //         } else {
  //           updatedSelectedOptiondetsils = {
  //             hierarchy: null,
  //             isPreferredTerm: null,
  //             conceptState: null,
  //             conceptFsn: term,
  //             definitionStatus: null,
  //             conceptId: null,
  //             languageCode: "en",
  //             typeId: null,
  //             term: term,
  //             caseSignificanceId: "CASE_INSENSITIVE",
  //             id: null,
  //             effectiveTime: null,
  //             activeStatus: null,
  //             moduleId: null,
  //           };
  //         }

  //         setAutoCompleteData([]);
  //         setFilteredOptions([]);
  //         setSuggestApiCalled(false);
  //         setDebounceFunctionCalled(true);
  //         if (foundData) {
  //           handleInputChange("term", updatedFound);
  //         } else {
  //           handleInputChange("term", updatedSelectedOptiondetsils);
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error(err);
  //   }
  // };

  const handleConditionTyped = (value) => {
    setProcedureName(value);

    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current); // Clear previous timeout
    // }

    // debounceTimeout.current = setTimeout(() => {
    //   handleAddOption(value); // Only triggers after user stops typing
    // }, 500); // Adjust delay as needed
  };

  console.log("Procedures data", procedures);
  return (
    <ThemeProvider theme={theme}>
      {activeSection && (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "5px",
                padding: "10px",
              }}
            >
              {fieldLayout.isFieldVisible("term", newProcedure) && (
                <Grid item {...fieldLayout.getFieldGrid("term", { xs: 10, sm: 8, md: 6 })}>
                  <StyledTextField
                    value={
                      // newProcedure.term !== "" ? newProcedure.term :
                      procedureName
                    }
                    onChange={(e) => {
                      // if (!newProcedure.term) {
                      //   setProcedureName(e.target.value);
                      // }
                      handleConditionTyped(e.target.value);
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        const shouldClear = !mouseDownOnOption;

                        if (shouldClear) {
                          // setIsFocused(false);
                          setFilteredOptions([]);
                          setDebounceFunctionCalled(false);
                          setTermSelectedOrAdded(false);
                        }

                        setMouseDownOnOption(false);
                      }, 100);
                    }}
                    onFocus={() => {
                      // setIsFocused(true);
                      if (procedureName.trim() !== "") {
                        debouncedFilterCall(procedureName.toLowerCase()); // re-trigger filtering
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            {fieldLayout.isCapabilityEnabled("term", "clear") && (
                              <Tooltip title="Clear">
                                <OutlinedIconFab
                                  size="small"
                                  variant="contained"
                                  onClick={handleClearName}
                                >
                                  <Icon name="clearTextField" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            )}
                          </div>
                          {/* {!termSelectedOrAdded && (
                        <Tooltip title="Add" style={{ marginRight: "5px" }}>
                          <OutlinedIconFab
                            size="small"
                            variant="contained"
                            onClick={handleAddOption}
                          >
                            <AddIcon />
                          </OutlinedIconFab>
                        </Tooltip>
                      )} */}
                          <>
                            {isAiEnabled &&
                              fieldLayout.isCapabilityEnabled("term", "voice") &&
                              (listeningOn === false ? (
                                <Tooltip title="Start Listening">
                                  <OutlinedIconFab
                                    // onClick={startListening}
                                    onClick={() => {
                                      startRecording();
                                      setListeningOn(true);
                                    }}
                                    variant="contained"
                                    // color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micNotInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Stop Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      // SpeechRecognition.stopListening();
                                      stopRecording("Procedures");
                                      setListeningOn(false);
                                    }}
                                    variant="outlined"
                                    // color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ))}
                          </>
                        </div>
                      ),
                    }}
                    label={fieldLayout.getFieldLabel("term", "Procedure Name", newProcedure)}
                    fullWidth
                    error={!!validationErrors.term}
                    helperText={validationErrors.term}
                  />
                  {filteredOptions.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "200px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      {/* Display filtered medicines */}
                      {suggestApiCalled && (
                        <div style={{ color: "red" }}>
                          No Exact Matches found ! You can search for the
                          following Suggestions.
                        </div>
                      )}

                      <>
                        {filteredOptions.map((op) => (
                          <div key={op}>
                            {
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {op.added ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <StyledButton
                                      color="success"
                                      sx={{
                                        textAlign: "left",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                      }}
                                    >
                                      {op.term}
                                    </StyledButton>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        flexDirection: "row",
                                        color: "green",
                                        fontStyle: "bold",
                                      }}
                                    >
                                      <span>&#10003;</span>
                                      <span>(Added)</span>
                                    </div>
                                  </div>
                                ) : (
                                  <StyledButton
                                    color="grey"
                                    sx={{
                                      textAlign: "left",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                    }}
                                    onClick={() => {
                                      skipEffect.current = true; // prevent debounce call
                                      optionChosen.current = true;
                                      setProcedureName(op.term);
                                      handleInputChange("term", op);
                                    }}
                                    onMouseDown={() => setMouseDownOnOption(true)}
                                  >
                                    {op.term}
                                  </StyledButton>
                                )}
                              </div>
                            }
                          </div>
                        ))}
                      </>
                    </div>
                  ) : filteredOptions.length == 0 &&
                    debounceFunctionCalled &&
                    !termSelectedOrAdded ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "300px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      <div style={{ color: "red" }}>No Options Found!</div>
                    </div>
                  ) : null}
                </Grid>
              )}
              {fieldLayout.isFieldVisible("clinical_note", newProcedure) && (
                <Grid item {...fieldLayout.getFieldGrid("clinical_note", { xs: 10, sm: 8, md: 6 })}>
                  <StyledMultilineTextField
                    value={newProcedure.clinical_note}
                    onChange={(e) =>
                      handleInputChange("clinical_note", e.target.value)
                    }
                    placeholder={fieldLayout.getFieldLabel("clinical_note", "Clinical Notes", newProcedure)}
                    fullWidth
                    error={!!validationErrors.clinical_note}
                    helperText={validationErrors.clinical_note}
                  />
                </Grid>
              )}
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <StyledButton
                  onClick={editingIndex != null ? handleUpdate : handleAdd}
                  variant="contained"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    width: "100%",
                  }}
                  bgColor="#0E3F66"
                >
                  {editingIndex != null ? "Update" : "Add"}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
      {procedures && (
        <ProceduresTable
          data={procedures}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
          fieldLayout={fieldLayout}
        />
      )}
    </ThemeProvider>
  );
};

export default Procedures;
